import request from "@/utils/request";

//获取banner
function getBanner() {
    return request.get('/cms/content/ac_news_list_banner')
}
//获取新闻列表
function getNewsList() {
    return request.get('/cms/section/ac_news_list')
}
//获取新闻详情
function getNewsDetail(id) {
    return request.get(`/cms/content/${id}`)
}
export default {
    getBanner,
    getNewsList,
    getNewsDetail
}